interface SaturedVaporPressureInterface {
  [key: string]: number;
}
export const SaturedVaporPressure: SaturedVaporPressureInterface = {
  "-10": 260,
  "-9": 284,
  "-8": 310,
  "-7": 338,
  "-6": 369,
  "-5": 402,
  "-4": 437,
  "-3": 476,
  "-2": 517,
  "-1": 562,
  "0": 611.2,
  "1": 657.1,
  "2": 705.9,
  "3": 758,
  "4": 813.5,
  "5": 872.5,
  "6": 935.2,
  "7": 1002,
  "8": 1073,
  "9": 1148,
  "10": 1228,
  "11": 1313,
  "12": 1403,
  "13": 1498,
  "14": 1599,
  "15": 1705,
  "16": 1818,
  "17": 1938,
  "18": 2064,
  "19": 2198,
  "20": 2339,
  "21": 2487,
  "22": 2644,
  "23": 2810,
  "24": 2985,
  "25": 3169,
  "26": 3363,
  "27": 3567,
  "28": 3782,
  "29": 4007,
  "30": 4245,
  "31": 4495,
  "32": 4757,
  "33": 5033,
  "34": 5323,
  "35": 5626,
  "36": 5946,
  "37": 6281,
  "38": 6631,
  "39": 6998,
  "40": 7381,
};

export const heatCurve = [-7, 2, 7, 12, 15, 20, 26];
export const heatCoefficient = [0.69, 0.81, 0.84, 0.9, 0.84, 0.82, 1];

export const APP_NEW_CONST = {
  "1/B": 0.0075008,
  Y: 2550,
  "B/B": 1,
};
